<template>
    <svg fill="#000000" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50" width="50px" height="50px"><path d="M 9 4 C 6.2504839 4 4 6.2504839 4 9 L 4 41 C 4 43.749516 6.2504839 46 9 46 L 41 46 C 43.749516 46 46 43.749516 46 41 L 46 9 C 46 6.2504839 43.749516 4 41 4 L 9 4 z M 9 6 L 41 6 C 42.668484 6 44 7.3315161 44 9 L 44 41 C 44 42.668484 42.668484 44 41 44 L 9 44 C 7.3315161 44 6 42.668484 6 41 L 6 9 C 6 7.3315161 7.3315161 6 9 6 z M 25 13 C 23.9 13 23 13.9 23 15 C 23 16.1 23.9 17 25 17 C 26.1 17 27 16.1 27 15 C 27 13.9 26.1 13 25 13 z M 11 24 L 11 26 L 39 26 L 39 24 L 11 24 z M 25 33 C 23.9 33 23 33.9 23 35 C 23 36.1 23.9 37 25 37 C 26.1 37 27 36.1 27 35 C 27 33.9 26.1 33 25 33 z"/></svg>
</template>

<script>
export default {
  name: 'Division'
}
</script>